import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import type { DynVarOption } from '../hooks/useDynamicVariables';

export type AgentVarSuggestionListProps = {
  items: DynVarOption[];
  command: (item: DynVarOption) => void;
};

export type AgentVarSuggestionListRef = {
  onKeyDown: (props: { event: KeyboardEvent }) => boolean;
};

export const AgentVarSuggestionList = forwardRef<
  AgentVarSuggestionListRef,
  AgentVarSuggestionListProps
>(({ items, command }, ref) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => setSelectedIndex(0), [items]);

  const selectItem = (index: number) => {
    const item = items[index];
    if (item) command(item);
  };

  useImperativeHandle(ref, () => ({
    onKeyDown: ({ event }) => {
      if (items.length === 0) return false;

      if (event.key === 'ArrowUp') {
        setSelectedIndex((i) => (i + items.length - 1) % items.length);
        return true;
      }
      if (event.key === 'ArrowDown') {
        setSelectedIndex((i) => (i + 1) % items.length);
        return true;
      }
      if (event.key === 'Enter' || event.key === 'Tab') {
        selectItem(selectedIndex);
        return true;
      }
      return false;
    },
  }));

  if (items.length === 0) {
    return <div className='mentionsNoData'>No data</div>;
  }

  return (
    <div className='agentVarSuggestList'>
      {items.map((o, i) => (
        <div
          key={o.key}
          className={`mentionOption agentVarSuggestOption${
            i === selectedIndex ? ' agentVarSuggestOption--active' : ''
          }`}
          onMouseDown={(e) => {
            e.preventDefault();
            selectItem(i);
          }}
        >
          <span className='mentionToken'>{o.token}</span>
          <span className='mentionLabel'>{o.label}</span>
        </div>
      ))}
    </div>
  );
});

AgentVarSuggestionList.displayName = 'AgentVarSuggestionList';
